import { Link, useBreakpoint } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { formatExcesses } from "./formatExcesses";
import type { ViewExcessModalProps } from "./Coverage";
import type { CoverLimitProps } from "../../CoverLimit";
import type { SpecificExcesses } from "../../../types";

export type ViewExcessProps = {
  displayName: string;
  displayExcess: string;
  quoteCardExcesses?: SpecificExcesses[];
  onOpen: ({ displayName, excesses }: ViewExcessModalProps) => void;
};

type CoverTitle = {
  displayName: string;
};

export const ViewExcess = ({
  displayName,
  displayExcess,
  quoteCardExcesses,
  onOpen,
}: ViewExcessProps) => {
  const { snowplow } = useSnowplowContext();
  const excesses: CoverLimitProps[] = formatExcesses(
    displayExcess,
    quoteCardExcesses,
  );
  const { down } = useBreakpoint();
  const isMobileDevice = down("md");

  const handleLinkClick = ({ displayName }: CoverTitle) => {
    snowplow?.trigger("deductiblesClickedUk", {
      label: displayName,
      deviceType: isMobileDevice ? "mobile" : "desktop",
    });
    onOpen({
      displayName,
      excesses,
    });
  };

  return (
    <>
      {excesses.length > 0 && (
        <Link
          className="mobius-quote-card__coverage-item-excess-link"
          onClick={() => handleLinkClick({ displayName })}
        >
          View excess
        </Link>
      )}
    </>
  );
};
